import Page from '../layout/Page';

export default Page;
